import * as Yup from 'yup';

export const TokenRecoveryValidation = Yup.object().shape({
    token: Yup.string().min(1).max(30).required('Campo obrigatório.')
})
